module.exports = __webpack_public_path__ + "img/ats-r-n1.934f8cdd.gif";